(() => {
  const infoBar = document.querySelector(".info-bar");
  const closeButton = document.querySelector(".info-bar__close");

  if (!infoBar || !closeButton) return;

  // Function to hide the info bar (using visibility to prevent CLS)
  const hideInfoBar = () => {
    infoBar.style.visibility = "hidden";
    infoBar.style.pointerEvents = "none";
    infoBar.setAttribute("aria-hidden", "true");
    localStorage.setItem("infoBarState", "hidden");
  };

  // Function to show the info bar
  const showInfoBar = () => {
    infoBar.style.visibility = "visible";
    infoBar.style.pointerEvents = "auto";
    infoBar.removeAttribute("aria-hidden");
    localStorage.setItem("infoBarState", "visible");
  };

  // Check local storage for the info bar state
  const infoBarState = localStorage.getItem("infoBarState");

  // If the state is not 'hidden' and the default state is not 'hide', show the bar
  if (infoBarState !== "hidden" && closeButton.getAttribute("state") !== "hide") {
    showInfoBar();
  } else {
    hideInfoBar();
  }

  // Add event listener to the close button
  closeButton.addEventListener("click", () => {
    hideInfoBar();
  });
})();
